import { render, staticRenderFns } from "./moveBottomNavigation.vue?vue&type=template&id=46731e17&scoped=true&"
import script from "./moveBottomNavigation.vue?vue&type=script&lang=js&"
export * from "./moveBottomNavigation.vue?vue&type=script&lang=js&"
import style0 from "./moveBottomNavigation.vue?vue&type=style&index=0&id=46731e17&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46731e17",
  null
  
)

export default component.exports